import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const testimonials = [{
  id: 1,
  name: 'Sofía L.',
  treatment: 'Estética Dental',
  quote: 'Nunca pensé que ir al dentista podría sentirse como visitar un spa de lujo. El resultado de mis carillas es simplemente una obra de arte.',
  img: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&q=80'
}, {
  id: 2,
  name: 'Martín G.',
  treatment: 'Implantes 3D',
  quote: 'La tecnología que utilizan es de otro planeta. Cero dolor, recuperación inmediata y un trato verdaderamente VIP desde el primer minuto.',
  img: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&q=80'
}, {
  id: 3,
  name: 'Valentina R.',
  treatment: 'Ortodoncia Invisible',
  quote: 'Buscaba discreción y resultados rápidos. El equipo de Lumière superó todas mis expectativas. Mi nueva sonrisa me ha cambiado la vida.',
  img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80'
}, {
  id: 4,
  name: 'Diego M.',
  treatment: 'Rehabilitación Completa',
  quote: 'Profesionalismo absoluto. El ambiente luminoso y relajante te quita cualquier ansiedad. Son los mejores en lo que hacen, sin duda.',
  img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80'
}];
export function Testimonials() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(scrollRef, {
    once: true
  });
  return <section id="testimonios" className="py-24 bg-surface relative z-20 overflow-hidden border-y border-line" data-id="element-119" data-mp="14uhfsqw0nju4">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12" data-id="element-120" data-mp="q6cwbkp534aa">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-121" data-mp="v4o3toryp2pc">
          <h2 className="font-serif text-4xl md:text-5xl text-ink mb-4" data-id="element-122" data-mp="1xfmvdaa0szvb">
            Sonrisas que Hablan <br data-id="element-123" data-mp="1sgtdl5npampc" />
            <span className="text-gold-deep italic" data-id="element-124" data-mp="1ohatgc3pefnk">por Sí Mismas</span>
          </h2>
        </motion.div>
      </div>

      {/* Carousel Container */}
      <div className="pl-6 md:pl-12 pb-8" data-id="element-125" data-mp="1jhg4wf7ei25o">
        <motion.div ref={scrollRef} className="flex gap-6 overflow-x-auto snap-x snap-mandatory scrollbar-hide pr-6 md:pr-12" initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-126" data-mp="1ej4tw15ddllv">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="min-w-[300px] md:min-w-[400px] bg-ivory p-8 rounded-xl snap-start border border-line hover:border-gold transition-colors duration-300" data-id="element-127" data-mp="qt0sm0fnlxy1" data-mpi={index}>
              <div className="flex items-center gap-4 mb-6" data-id="element-128" data-mp="2sozx2eq9lbw2">
                <img src={testimonial.img} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover border-2 border-gold" data-id="element-129" data-mp="2xiultwkq8h20" />
                <div data-id="element-130" data-mp="25076yywbpy9d">
                  <h4 className="font-serif text-lg text-ink" data-id="element-131" data-mp="24zp078c1c1n7">
                    {testimonial.name}
                  </h4>
                  <p className="font-sans text-xs text-gold-deep uppercase tracking-wider" data-id="element-132" data-mp="1gxtwhenyaktj">
                    {testimonial.treatment}
                  </p>
                </div>
              </div>
              <p className="font-sans text-ink-soft italic leading-relaxed" data-id="element-133" data-mp="1qvzwtru3ziwa">
                "{testimonial.quote}"
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}